// ClientDetail.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Classes from "./ClientDetail.module.css";
import Sidebar from "./Components/Sidebar/Sidebar";
import Details from "./Components/Details/Details";
import Invoices from "./Components/Invoices/Invoices";
import Documents from "./Components/Documents/Documents";
import Appointments from "./Components/Appointments/Appointments";
import MoreDropDown from "./MoreDropDown";
import { LeftArrowIcon } from "../../../../../../utils/Icons";
import backend from "../../../../../../api";

export default function ClientDetail() {
  const navigateTo = useNavigate();
  const { tab = "details", id } = useParams();
  const [activeTab, setActiveTab] = useState(tab);
  const [loading, setLoading] = useState(true);
  const [bundle, setBundle] = useState({ user: null, bookings: [], invoices: [] });

  useEffect(() => setActiveTab(tab), [tab]);

  useEffect(() => {
    let alive = true;
    async function load() {
      if (!id) return;
      setLoading(true);
      try {
        const { data } = await backend.get(`/api/user/${id}/deep`);
        if (!alive) return;
        setBundle({
          user: data?.user || null,
          bookings: data?.bookings || [],
          invoices: data?.invoices || [],
        });
      } finally {
        if (alive) setLoading(false);
      }
    }
    load();
    return () => { alive = false; };
  }, [id]);

  return (
    <div className={Classes.container}>
      <div className={Classes.header}>
        <button onClick={() => navigateTo(-1)} className={Classes.backButton}>
          <LeftArrowIcon height="12px" fill="#969696" />
          <h5>Clients</h5>
        </button>
        <MoreDropDown userId={id} user={bundle.user} />
      </div>

      <div className={Classes.hero}>
        <div className={Classes.heroLeft}>
          <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>

        <div className={Classes.heroRight}>
          <div className="flexAlign10 mb-20">
            <h3 className={Classes.mainTitle}> {bundle && bundle?.user && bundle?.user?.firstName + ' ' + bundle?.user?.lastName || bundle?.user?.email} </h3>
          </div>

          {activeTab === "details" && (
            <Details
              loading={loading}
              user={bundle.user}
              bookings={bundle.bookings}
              invoices={bundle.invoices}
            />
          )}
          {activeTab === "appointments" && (
            <Appointments
              loading={loading}
              bookings={bundle.bookings}
              userId={id}
            />
          )}
          {activeTab === "invoices" && (
            <Invoices
              loading={loading}
              invoices={bundle.invoices}
              userId={id}
            />
          )}
          {activeTab === "documents" && (
            <Documents
              loading={loading}
              user={bundle.user}
              userId={id}
            />
          )}
        </div>
      </div>
    </div>
  );
}
